module.exports = __webpack_public_path__ + "static/img/exchange-log-default.08a68d10.png";